import React, { Component } from "react";

import eu_vauch from "../images/logos_eu_vauch.png";

class EUProjekti extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div id="eu-projekti-style">
        <div className="content">
          <div className="text-content">
            <h1>EU Projekti</h1> <h2>Vavčer za patente, modele, znamke</h2>
            <ul>
              <li>
                V okviru javnega razpisa V2 Vavčer za patente, modele, znamke bo podjetje Intrakon d.o.o. najkasneje do
                10. 12. 2026 izvedlo projekt Registracija blagovne znamke. Upravičeni stroški projekta so ocenjeni na
                1.700, 00 EUR, predvidena višina sofinanciranja pa lahko znaša do 1.020, 00 EUR.
              </li>
              <li>Financira Evropska unija – NextGenerationEU</li>
              <li>
                Spletna stran evropske kohezijske politike v Sloveniji:{" "}
                <a href="https://www.evropskasredstva.si" target="_blank" rel="noreferrer">
                  www.evropskasredstva.si
                </a>
              </li>
            </ul>
          </div>
          <div className="image-container">
            <img src={eu_vauch} alt="EU Vauch" />
          </div>
        </div>
      </div>
    );
  }
}

export default EUProjekti;
